import mitt from 'mitt';

export const HISTORY_POP_EVENT = 'HISTORY_POP_EVENT';

type Events = {
    [HISTORY_POP_EVENT]: string,
};
export default mitt<Events>();
